import { Controller } from "@hotwired/stimulus";
import { storage } from "../../../storageconstants";

export default class extends Controller {
  static targets = [
    "firstName",
    "lastName",
    "email",
    "validationResult",
    "connectWalletBtn",
  ];

  static values = {
    code: String,
    session: String,
  }

  connect() {
    this.hideLoadingScreen();

    // Necessary to read from session storage
    // Because values cannot be read from X-Headers
    this.codeValue = sessionStorage.getItem(storage.CODE);

    // Server-side prefill (personal-info skip back-navigation) must enable
    // the Continue button without requiring a keystroke.
    this.checkValidation();
  }

  validateName(field, nameString) {
    if (nameString.length === 0) return false;

    // Check if all characters are letters.
    const characters = nameString.trim();

    // Check if characters are not numbers or special characters.
    const charactersAreValid = /^[\p{L} ]+$/u.test(characters);

    if (!charactersAreValid) return `Invalid character(s) in ${field}.`;
    
    return true;
  }

  validateEmail(email) {
    if (email.length === 0) return false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) ? true : "Please enter a valid email address.";
  }

  createValidationFeedbackBullet(string) {
    const bullet = document.createElement("li");
    bullet.textContent = string;
    return bullet;
  }

  checkValidation() {
    // Clear earlier validation feedback;
    this.validationResultTarget.innerHTML = "";

    const firstNameValidation = this.validateName("First Name", this.firstNameTarget.value);
    const lastNameValidation = this.validateName("Last Name", this.lastNameTarget.value);
    const emailValidation = this.validateEmail(this.emailTarget.value);

    const validationIsSuccessful = firstNameValidation === true && lastNameValidation === true && emailValidation === true;

    this.connectWalletBtnTarget.classList.toggle("is-disabled", !validationIsSuccessful);

    if (!validationIsSuccessful) {
      if (typeof firstNameValidation === "string") this.validationResultTarget.appendChild(this.createValidationFeedbackBullet(firstNameValidation));
      if (typeof lastNameValidation === "string") this.validationResultTarget.appendChild(this.createValidationFeedbackBullet(lastNameValidation));
      if (typeof emailValidation === "string") this.validationResultTarget.appendChild(this.createValidationFeedbackBullet(emailValidation));
    }
  }

  async connectButtonHandler(_) {
    this.showLoadingScreen();

    const form = document.getElementById("frame-post-form");
    form.action = `/${this.codeValue}/payment-options?session=${this.sessionValue}`;
    form.requestSubmit();
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
